import { render } from "./TablePlaceholderLoading.vue?vue&type=template&id=2789732f&scoped=true&ts=true"
import script from "./TablePlaceholderLoading.vue?vue&type=script&lang=ts"
export * from "./TablePlaceholderLoading.vue?vue&type=script&lang=ts"

import "./TablePlaceholderLoading.vue?vue&type=style&index=0&id=2789732f&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789732f"]])

export default __exports__